import React, { useEffect } from 'react';
import { CONSENT_CONTRACT_PATHS } from 'constants/consent-contracts-paths';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ContractsReceiptWrapper, HelixLoader } from 'components';
import { toLocalDateTimeString } from 'lib';
import { useWalletList } from 'hooks';
import {
    DisplayItem,
    getContractOwnerIdOrEffectiveIdName,
    getLoggedInIdName,
} from 'components/contracts-receipt-wrapper/contracts-receipt-wrapper-helper';

export const ConsentContractReceipts = (): React.JSX.Element => {
    const { sdoId, chain } = useParams();
    const { data: walletsData, isLoading: walletsLoading } = useWalletList();
    const navigate = useNavigate();
    const location = useLocation();
    const receiptData = location.state;

    useEffect(() => {
        if (!location.state) {
            navigate(`${CONSENT_CONTRACT_PATHS.LANDING_PAGE}?tab=Receipts`, {
                state: chain,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const onBackArrowClick = (): void => {
        navigate(`${CONSENT_CONTRACT_PATHS.LANDING_PAGE}?tab=Receipts`, {
            state: chain,
        });
    };

    const informationDisplayItems: DisplayItem[] = [
        {
            label: 'SDOID',
            value: sdoId ?? '--',
        },
        {
            label: 'Contract Owner',
            value: getContractOwnerIdOrEffectiveIdName(
                walletsData,
                receiptData?.contractOwnerId
            ),
        },
        {
            label: 'EffectiveID',
            value: getContractOwnerIdOrEffectiveIdName(
                walletsData,
                receiptData?.effectiveId
            ),
        },
        {
            label: 'LoggedInID',
            value: getLoggedInIdName(walletsData, receiptData?.loggedInId),
        },
        {
            label: 'TQL',
            value: receiptData?.receiptConsentContract?.tqlBase64
                ? atob(receiptData?.receiptConsentContract?.tqlBase64)
                : '',
            isCode: true,
        },
    ];

    const headerDisplayItems: DisplayItem[] = [
        {
            label: 'Timestamp',
            value:
                toLocalDateTimeString(receiptData?.header?.timestamp) ?? '--',
        },
        {
            label: 'ID',
            value: receiptData?.header?.id ?? '--',
        },
        {
            label: 'Type',
            value: receiptData?.header?.type ?? '--',
        },
        {
            label: 'Operation',
            value: receiptData?.header?.operation ?? '--',
        },
        {
            label: 'Owners',
            value: receiptData?.header?.owners ?? '--',
        },
        {
            label: 'Limited Owners',
            value: receiptData?.header?.limitedOwners ?? '--',
        },
        {
            label: 'Signer',
            value: receiptData?.header?.signer ?? '--',
        },
        {
            label: 'Signature',
            value: receiptData?.header?.signature ?? '--',
        },
        {
            label: 'Dictionary',
            value: receiptData?.header?.dictionary ?? '--',
        },
        {
            label: 'Hash',
            value: receiptData?.header?.hash ?? '--',
        },
    ];

    if (walletsLoading) {
        return <HelixLoader />;
    }

    return (
        <ContractsReceiptWrapper
            chain={chain ?? ''}
            breadCrumType='Consent_Contract'
            onBackArrowClick={onBackArrowClick}
            informationDisplayItems={informationDisplayItems}
            headerDisplayItems={headerDisplayItems}
        />
    );
};
